import { getHeadquarters } from "../data/companyHeadquarters";
import type { Job, ResolvedJob } from "../types/job";

/**
 * HQ dictionary overrides per-job lat/lng when an entry exists.
 * Otherwise uses lat/lng from the job JSON.
 */
export function resolveJobCoordinates(job: Job): ResolvedJob | null {
  const hq = getHeadquarters(job.company);
  const lat = hq?.lat ?? job.lat;
  const lng = hq?.lng ?? job.lng;

  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    console.warn(
      `[calijobs.dev] Missing coordinates for "${job.company}" (${job.id}). Add an entry in src/data/companyHeadquarters.ts or set lat/lng on the job.`,
    );
    return null;
  }

  return { ...job, lat, lng };
}

export function resolveAllJobs(raw: Job[]): ResolvedJob[] {
  const resolved = raw
    .map(resolveJobCoordinates)
    .filter((j): j is ResolvedJob => j !== null);
  const seen = new Set<string>();
  const out: ResolvedJob[] = [];
  for (const j of resolved) {
    if (seen.has(j.id)) {
      console.warn(
        `[calijobs.dev] Duplicate job id "${j.id}" — skipping duplicate row so the map and list stay in sync.`,
      );
      continue;
    }
    seen.add(j.id);
    out.push(j);
  }
  return out;
}
